export default __webpack_public_path__ + "static/media/Meat-1.edd50662.png";